import styled from 'styled-components';

export const TemplateDescriptionText = styled.p`
  margin-top: 0;
  margin-bottom: 0;
  margin-right: 5px;
`;

export const TemplateDescription = styled.div`
  display: flex;
`;
